import {ScanQRCodeUseCase} from '../../domain/scan/usecases/ScanQRCodeUseCase';
import {GetAvailableServicesUseCase} from '../../domain/scan/usecases/GetAvailableServicesUseCase';
import {GetAvailableServicesFromEligibilityUseCase} from '../../domain/scan/usecases/GetAvailableServicesFromEligibilityUseCase';
import {GetAssignmentByIdUseCase} from '../../domain/scan/usecases/GetAssignmentByIdUseCase';
import {CreateDeliveryUseCase} from '../../domain/scan/usecases/CreateDeliveryUseCase';
import {CreateAssignmentUseCase} from '../../domain/scan/usecases/CreateAssignmentUseCase';
import {UpdateDeliveryUseCase} from '../../domain/scan/usecases/UpdateDeliveryUseCase';
import {GetCaseDetailUseCase} from '../../domain/scan/usecases/GetCaseDetailUseCase';
import {Beneficiary} from '../../domain/scan/entities/Beneficiary';
import {Service} from '../../domain/scan/entities/Service';
import {AssignmentDetail} from '../../domain/scan/entities/AssignmentDetail';
import {Delivery, CreateDeliveryRequest} from '../../domain/scan/entities/Delivery';
import {CaseDetail} from '../../domain/scan/entities/CaseDetail';
import {UpdateDeliveryRequest, CreateAssignmentRequest} from '../../domain/scan/repositories/ScanRepository';

export class ScanService {
  constructor(
    private readonly scanQRCodeUseCase: ScanQRCodeUseCase,
    private readonly getAvailableServicesUseCase: GetAvailableServicesUseCase,
    private readonly getAvailableServicesFromEligibilityUseCase: GetAvailableServicesFromEligibilityUseCase,
    private readonly getAssignmentByIdUseCase: GetAssignmentByIdUseCase,
    private readonly createDeliveryUseCase: CreateDeliveryUseCase,
    private readonly createAssignmentUseCase: CreateAssignmentUseCase,
    private readonly updateDeliveryUseCase: UpdateDeliveryUseCase,
    private readonly getCaseDetailUseCase: GetCaseDetailUseCase,
  ) {}

  async scanQRCode(qrCode: string): Promise<Beneficiary> {
    return await this.scanQRCodeUseCase.execute(qrCode);
  }

  async getAvailableServices(): Promise<Service[]> {
    return await this.getAvailableServicesUseCase.execute();
  }

  async getAvailableServicesFromEligibility(caseUserId: number): Promise<Service[]> {
    return await this.getAvailableServicesFromEligibilityUseCase.execute(caseUserId);
  }

  async getAssignmentById(assignmentId: number): Promise<AssignmentDetail> {
    return await this.getAssignmentByIdUseCase.execute(assignmentId);
  }

  async createAssignment(request: CreateAssignmentRequest): Promise<{id: number}> {
    return await this.createAssignmentUseCase.execute(request);
  }

  async createDelivery(request: CreateDeliveryRequest): Promise<Delivery> {
    return await this.createDeliveryUseCase.execute(request);
  }

  async updateDelivery(request: UpdateDeliveryRequest): Promise<Delivery> {
    return await this.updateDeliveryUseCase.execute(request);
  }

  async getCaseDetail(caseId: number): Promise<CaseDetail> {
    return await this.getCaseDetailUseCase.execute(caseId);
  }
}
